import 'quill-mention';
import { Quill } from 'react-quill';
import React, { useEffect } from 'react';

import './styles/QuillEditor.scss';
import 'react-quill/dist/quill.snow.css';

const QuillViewer = ({ value, className = '', ...props }) => {
  useEffect(() => {
    const q = new Quill(`#${props.id || 'comment-input-editor'}`, {
      readOnly: props.readOnly,
    });

    if (value) {
      q.root.innerHTML = value;
    }
  }, [value]);

  return <div id={props.id || `comment-input-editor`} className={className} translate='no'></div>;
};

export default QuillViewer;
